export default "__VITE_PUBLIC_ASSET__562f18ed__"